export const isFetchingEntities = (state, entities) =>
  entities.some(entityName => state.app.fetchingActions.includes(entityName));

export default isFetchingEntities;
